<script lang="ts">
	import { DeviceSelector } from "luxedo-comps"
	import type { DeviceData } from "../../types"

	interface Props {
		onSelect: (dev: DeviceData) => void
		selectedDevice: DeviceData
		availableDevices: DeviceData[]
	}

	let { onSelect, selectedDevice, availableDevices }: Props = $props()
</script>

<div class="select-device">
	{#each availableDevices as dev}
		<DeviceSelector
			deviceId={Number(dev.id)}
			onSelect={() => onSelect(dev)}
			isSelected={selectedDevice?.id === dev.id}
			type={"radio"}
		/>
	{/each}
</div>

<style>
	.select-device {
		flex-grow: 1;
		height: 100%;
		overflow-y: auto;
	}
</style>
